import axios from '../../service/index'
import React, { Component } from 'react'
import ReactDOM from 'react-dom';
import E from 'wangeditor'
import { Button, Divider,  message, Form, Input,Upload } from 'antd'

import './zipPackage.less'
let qiniuUpUrl = 'https://up-z1.qiniup.com'
class AddOrUpdateForm extends Component {
  state = {
    datumName: '',
    packagefile: '',
    helpPeople: '',
    drawPeople: '',
    describe: '',
    presetNum: '',
    fileList: [],
    postor: {},
    editor: '',
    iconLoading: false,
    typeTitel:'add',
    subjectId: '',
    subjectName: '',
    zipId: '',
    token: '',
    url: '',
    editorHtml: '',
    editorText: '',
    infoObj: {}
  }
  componentDidMount() {
    this.getToken()
    let {typeTitel, subjectId, subjectName, zipId} = this.props.location.state
    this.setState({typeTitel, subjectId, subjectName, zipId}, () => {
      if(this.state.typeTitel === 'edit'){
        this.getZipDetail()
      }
    })
    let editor = new E(ReactDOM.findDOMNode(this._div))
		this.setState({ editor: editor })
		editor.config.menus = [
			'head',
			'bold',
			'fontSize',
			'fontName',
			'italic',
			'underline',
			'strikeThrough',
			'indent',
			'lineHeight',
			'foreColor',
			'backColor',
			'link',
			'list',
			'todo',
			'justify',
			'quote',
			'table',
			'splitLine',
			'undo',
			'redo',
			'image',
		]
		editor.config.uploadImgMaxLength = 5;
		editor.config.showLinkImg = false;
		editor.config.uploadImgServer = "/upload"; //上传图片的server接口地址
		editor.config.withCredentials = false;
		editor.config.uploadImgTimeout = 5 * 1000;
		let _this = this
    editor.config.customUploadImg = function (resultFiles, insertImgFn) {
			let imgUrl = ''
			let data = new FormData();
			data.append("token", _this.state.token);
			data.append("file", resultFiles[0]);
			axios({
				method: "POST",
				url: qiniuUpUrl,
				data: data,
				onUploadProgress: function (progressEvent) {
				},
			}).then((res) => {
				imgUrl = _this.state.url + '/' + res.data.key
				insertImgFn(imgUrl);
			});
		};
		editor.config.onchange = (html) => {
			this.setState({
				editorHtml: html,
				editorText: editor.txt.text()
			})
			//将html值设为form表单的desc属性值
			this.props.form.setFieldsValue({
				'describe': html
			});
		}
    editor.create()
  }
  getToken=() =>{
		let _this = this;
		axios.get("/uplodController/get7menrToken").then((res) => {
			if (res.data.code === '200') {
				_this.setState({
					token: res.data.data.token,
					url: res.data.data.url
				})
			} else {
				message.error('七牛token获取失败')
			}
		}).catch((e) => {
			console.log(e)
		})
	}
  getZipDetail() {
    axios.get(`/datum/info/${this.state.zipId}`).then(res => {
      if (res.data.code === '200') {
      this.setState({infoObj: res.data.data},() => {
        this.state.editor.txt.html(this.state.infoObj.describe)
        this.props.form.setFieldsValue({
          postor: [{url: this.state.infoObj.fileUrl, uid: 'FirjdGoj0FyX6rVCgEPzouRC78dJ', name: this.state.infoObj.fileName}]
        })
      })
    }
    })
  }
  powerValidateForm = (rule, value, callback) => {
    let reg = /^([0]|[1-9][0-9]*)$/
    if(value&&!reg.test(value)) {
      callback('请输入正整数')
    }else if(value && (value<1||value>10)){
      callback('请输入大于等于1小于10的正整数')
    }else{
      callback()
    }
  }
  presetValidateForm = (rule, value, callback) => {
    let reg = /^([0]|[1-9][0-9]*)$/
    if(value&&!reg.test(value)) {
      callback('请输入正整数')
    }else if(value&&value<1){
      callback('请输入大于等于1的正整数')
    }else{
      callback()
    }
  }
  submitOk = (e) => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if(!err) {
        // console.log(values)
        let params = {
          datumName: values.datumName,
          describe: values.describe,
          drawPeople: values.drawPeople,
          helpPeople: values.helpPeople,
          subjectId: this.state.subjectId,
          fileName: values.postor[0].name,
          fileUrl: values.postor[0].url?values.postor[0].url:this.state.url+'/'+values.postor[0].response.key
        }
        // console.log(params)
        if(this.state.typeTitel === 'add'){
          delete params.id
        }else {
          params.id = this.state.zipId
        }
        let url = this.state.typeTitel === 'add'?'datum/save':'datum/update'
        axios.post(url, params).then(res => {
          if(res.data.code !== '200')return message.error(res.data.msg)
          this.props.form.resetFields()
          this.state.editor.txt.html('<p><br></p>')
          message.success(`${this.state.typeTitel === 'add'?'新增':'编辑'}成功`)
          this.props.history.push('/detail',{subjectId: this.state.subjectId, subjectName: this.state.subjectName})
        })
      }
    })
  }
  handleReset = () => {
    let {subjectId, subjectName} = this.state
    this.props.form.resetFields();
    this.state.editor.txt.html('<p><br></p>')
    this.props.history.push('/detail',{subjectId, subjectName})
  }
  normFile = e => {
		if (e.fileList.length === 2) {
			e.fileList = e.fileList.slice(-1);
			message.warning("一个版本只能上传一个文件")
		};
		if (Array.isArray(e)) {
			return e;
		}
		return e && e.fileList;
	};
  handleChangefile = ({file, fileList}) => {
    console.log(file, fileList)
    if (file.percent === 100) {
      if (file.status === 'done') {
        let fileL = {
					uid: fileList[0].uid,
					name: fileList[0].name,
					status: fileList[0].status,
					url: this.state.url + '/' + fileList[0].response.hash,
					type: fileList[0].type
				}
				this.setState({ fileList: fileL });
      }
    }
  }
  render() {
    let { typeTitel, subjectId, subjectName, infoObj} = this.state
    const { getFieldDecorator } = this.props.form;
    const tailLayout = {
      wrapperCol: { offset: 3, span: 12 },
    }
    return (
      <div className="modal-pack">
        <div className="header-between">
          <span className="header-name">{typeTitel === 'add'?'新增':'编辑'}资料包</span>
          <span className="my-button-txt" onClick={()=>{
              this.props.history.push('/detail',{subjectId, subjectName})
            }}>返回上一级</span>
          </div>
				<Divider />
          <Form labelCol={{ span: 3 }} wrapperCol={{ span: 12 }} onSubmit={this.submitOk}>
						<Form.Item label="资料包名称" name="datumName">
              {getFieldDecorator('datumName', {
              rules: [
                {required: true,message: '请输入资料包名称'},
                {max: 50,message: '最多输入50个字!'}
              ],
              initialValue: typeTitel === 'edit'?infoObj.datumName:''
            })(<Input />)}
						</Form.Item>
            <Form.Item label="资料包文件" name="postor">
              {getFieldDecorator('postor', {
              rules: [
                {required: true, message: '请上传文件'}
              ],
              valuePropName: 'fileList',
							getValueFromEvent: this.normFile,
            })(
              // <div className="file-css">
                <Upload
                  action={qiniuUpUrl}
                  accept=".doc, .docx, .xls, .xlsx, .ppt, .pptx, .pdf"
                  listType='picture'
                  beforeUpload={(file, fileList) => {
                    const isLt10M = file.size / 1024 / 1024 <= 200;
                    if (!isLt10M) {
                      return	message.error("文件大小限制在200M以下！");
                    }
                  }}
                  onChange={this.handleChangefile}
                  data={{ token: this.state.token }}
                  >
                    <Button type="primary" className="my-button-primary">选择文件</Button>
                    <p style={{margin:0,height: "20px",color: '#ccc'}}>1.支持.doc, .docx, .xls, .xlsx, .ppt, .pptx, .pdf格式，大小不超过200MB</p>
                    <p style={{margin:0,height: "20px",color: '#ccc'}}>2.只能上传一个文件</p>
                </Upload>
                
              // </div>
            )}
						</Form.Item>
            <Form.Item label="所需助力人数" name="helpPeople">
              {getFieldDecorator('helpPeople', {
              rules: [
                {required: true, message: '请输入所需助力人数'},
                { validator: this.powerValidateForm }
              ],
              initialValue: typeTitel === 'edit'?infoObj.helpPeople:''
            })(<Input disabled={typeTitel === 'edit'&&infoObj.helpPeople!==0? true: false} placeholder="请输入大于等于1小于10的正整数" />)}
						</Form.Item>
            <Form.Item label="预设领取资料人数" name="drawPeople">
              {getFieldDecorator('drawPeople', {
              rules: [
                { validator: this.presetValidateForm }
              ],
              initialValue: typeTitel === 'edit'?infoObj.drawPeople:''
            })(<Input disabled={typeTitel === 'edit'&&infoObj.drawPeople !== 0? true: false} placeholder="请输入大于等于1的正整数" />)}
						</Form.Item>
            <Form.Item label="资料包详情">
              {getFieldDecorator('describe', {
              initialValue: typeTitel === 'edit'?infoObj.describe:''
            })(
							<div ref={(ref) => this._div = ref}></div>
						)}
						</Form.Item>
            <Form.Item {...tailLayout}>
            <Button  onClick={this.handleReset}>
              取消
            </Button>
            <Button style={{ marginLeft: 8 }} type="primary" htmlType="submit">
              确定
            </Button>
						</Form.Item>
					</Form>
      </div>
    )
  }
}
export default Form.create()(AddOrUpdateForm)
